<template>
  <v-card elevation="2">
    <v-card-title class="headline">
      Gerenciamento de Intervalos de Preço
    </v-card-title>

    <v-stepper v-model="step" flat>
      <v-stepper-items>
        <v-stepper-content step="1">
          <v-container fluid>
            <v-row>
              <v-col cols="12">
                <v-data-table
                  :headers="headers"
                  :items="intervalos"
                  :server-items-length="totalItens"
                  :loading="carregando"
                  class="elevation-0"
                  dense
                  hide-default-footer
                  @update:page="pagination.page = $event"
                >
                  <template v-slot:top>
                    <v-toolbar flat color="transparent">
                      <v-spacer></v-spacer>
                      <v-btn color="primary" @click="irParaCadastro">
                        <v-icon left>mdi-plus</v-icon>
                        Cadastrar
                      </v-btn>
                    </v-toolbar>
                  </template>

                  <template v-slot:body="{ items }">
                    <tbody>
                      <tr v-for="(item, index) in items" :key="item.id">
                        <td>{{ item.min.toFixed(2).replace('.', ',') }}</td>
                        <td>{{ item.max.toFixed(2).replace('.', ',') }}</td>
                        <td>{{ item.desconto }}%</td>
                        <td class="text-right">
                          <v-btn icon small @click="editarIntervalo(index)">
                            <v-icon>mdi-pencil</v-icon>
                          </v-btn>
                          <v-btn icon small color="red" @click="removerIntervalo (index)">
                            <v-icon>mdi-delete</v-icon>
                          </v-btn>
                        </td>
                      </tr>
                    </tbody>
                  </template>
                </v-data-table>
              </v-col>
            </v-row>

            <v-row align="center" justify="center">
              <v-col cols="12" md="6">
                <v-pagination
                  v-model="pagination.page"
                  :length="pages"
                  total-visible="7"
                ></v-pagination>
              </v-col>
            </v-row>
          </v-container>
        </v-stepper-content>

        <v-stepper-content step="2">
          <v-container>
            <v-form ref="form" v-model="valid" lazy-validation>
              <v-row>
                <v-col cols="12" md="6">
                  <v-text-field
                    v-model="novoIntervalo.min"
                    label="Valor Mínimo (R$)"
                    outlined
                    dense
                    required
                    @input="formatarValorMonetario('min')"
                    :rules="[v => !!v || 'Campo obrigatório']"
                  />
                </v-col>

                <v-col cols="12" md="6">
                  <v-text-field
                    v-model="novoIntervalo.max"
                    label="Valor Máximo (R$)"
                    outlined
                    dense
                    required
                    @input="formatarValorMonetario('max')"
                    :rules="[v => !!v || 'Campo obrigatório']"
                  />
                </v-col>

                <v-col cols="12">
                  <v-text-field
                    v-model.number="novoIntervalo.desconto"
                    label="Desconto (%)"
                    outlined
                    dense
                    required
                    type="number"
                    :rules="[v => !!v || 'Campo obrigatório']"
                  />
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="12" class="text-right">
                  <v-btn text @click="voltarParaLista">Cancelar</v-btn>
                  <v-btn color="primary" @click="salvarIntervalo" :disabled="!valid">
                    <v-icon left>mdi-content-save</v-icon>Salvar
                  </v-btn>
                </v-col>
              </v-row>
            </v-form>
          </v-container>
        </v-stepper-content>
      </v-stepper-items>
    </v-stepper>
  </v-card>
</template>

<script>
export default {
  data () {
    return {
      step: 1,
      valid: false,
      editando: false,
      editandoIndex: null,
      novoIntervalo: {
        min: null,
        max: null,
        desconto: null
      },
      intervalos: [],
      pagination: {
        page: 1,
        rowsPerPage: 5
      },
      totalItens: 0,
      carregando: false,
      headers: [
        { text: 'Valor Mínimo (R$)', value: 'min' },
        { text: 'Valor Máximo (R$)', value: 'max' },
        { text: 'Desconto (%)', value: 'desconto' },
        { text: 'Ações', value: 'actions', sortable: false }
      ]
    }
  },
  watch: {
    pagination: {
      handler () {
        this.carregarIntervalos()
      },
      deep: true
    }
  },
  computed: {
    pages () {
      const count = this.totalItens
      if (this.pagination.rowsPerPage == null || count == null) return 0

      return Math.ceil(count / this.pagination.rowsPerPage)
    }
  },
  methods: {
    formatarValorMonetario (campo) {
      let valor = this.novoIntervalo[campo]
      valor = valor.replace(/[^\d]/g, '')

      const numero = parseFloat(valor) / 100
      this.novoIntervalo[campo] = numero
        ? `R$ ${numero.toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.')}`
        : ''
    },
    irParaCadastro () {
      this.step = 2
      this.limparFormulario()
    },
    voltarParaLista () {
      this.step = 1
      this.limparFormulario()
    },
    carregarPagina (pagina) {
      this.carregarIntervalos(pagina)
    },
    carregarIntervalos () {
      this.carregando = true
      this.$store.dispatch('PegarIntervalosAssinatura', {
        page: this.pagination.page
      }).then(json => {
        this.intervalos = json.results.map(item => ({
          id: item.id,
          min: parseFloat(item.preco_min) || 0,
          max: parseFloat(item.preco_max) || 0,
          desconto: item.percentual
        }))
        this.totalItens = json.count
      }).finally(() => {
        this.carregando = false
      })
    },
    salvarIntervalo () {
      if (this.valid) {
        const method = this.editando ? 'PUT' : 'POST'
        const payload = {
          preco_min: parseFloat(String(this.novoIntervalo.min).replace('R$', '').replace(/\./g, '').replace(',', '.')),
          preco_max: parseFloat(String(this.novoIntervalo.max).replace('R$', '').replace(/\./g, '').replace(',', '.')),
          percentual: this.novoIntervalo.desconto
        }

        if (this.editando) {
          payload.id = this.intervalos[this.editandoIndex].id
        }

        this.$store.dispatch('CadastrarIntervalosAssinatura', { method, payload })
          .then(() => {
            this.carregarIntervalos()
            this.voltarParaLista()
          })
      }
    },
    editarIntervalo (index) {
      const intervalo = this.intervalos[index]

      this.novoIntervalo = {
        min: intervalo.min !== undefined && intervalo.min !== null
          ? `R$ ${intervalo.min.toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.')}`
          : 'R$ 0,00',
        max: intervalo.max !== undefined && intervalo.max !== null
          ? `R$ ${intervalo.max.toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.')}`
          : 'R$ 0,00',
        desconto: intervalo.desconto
      }

      this.editando = true
      this.editandoIndex = index
      this.step = 2
    },
    limparFormulario () {
      this.novoIntervalo = { min: null, max: null, desconto: null }
      this.editando = false
      this.editandoIndex = null
      this.$refs.form.resetValidation()
    },
    removerIntervalo (index) {
      const intervalo = this.intervalos[index]

      this.$store.dispatch('deletarIntervaloAssinatura', { id: intervalo.id })
        .then(() => {
          this.carregarIntervalos()
        })
    }
  },
  beforeMount () {
    this.carregarIntervalos()
  }
}
</script>

  <style scoped>
  .text-right {
    text-align: right;
  }
  </style>
